import { Buffer } from "buffer";

window.Buffer = window.Buffer || Buffer;
